/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { type HttpResponse, I18nService } from '@dm/core';
import { FeatureConfig } from 'app/config/feature';
import { pick } from 'lodash';
import { type Observable } from 'rxjs';

import { LunService } from '../../../../../../service/block-service/lun-entry/lun/lun.service';
import { LunsConst } from '../../../../../../service/block-service/lun-group/luns.const';
import { GlobalSearchService } from '../../../../global-search.service';
import { InfigoService } from '../../../infigo.service';
import { SourceEnumService } from '../../../source-enum.service';
import { RefreshComponent } from '../../RefreshComponent';

const HASRSSOBJECT = [
    'SnapShot',
    'LunClone',
    'HyperCDP',
    'RemoteReplication',
    'HyperMetro',
    'drStar',
];

@Component({
    selector: 'app-recycle-bin-base-info',
    templateUrl: './recycle-bin-base-info.component.html',
})
export class RecycleBinBaseInfoComponent extends RefreshComponent {
    @Input() item;
    Number = Number;
    baseInfo;
    detail: any = {};
    loading = true;
    capacityPercentData = 0;
    threSholdList = [];

    constructor(private infigoService: InfigoService,
        private lunService: LunService,
        public str: LunsConst,
        public i18n: I18nService,
        public enumService: SourceEnumService,
        public global: GlobalSearchService,
        public changeDetectorRef: ChangeDetectorRef) {
        super();
        const I18N = i18n.get;
        const enumGet = enumService.get.bind(enumService, 'LUN');
        this.baseInfo = [
            {
                title: I18N('common.healthStatus_column'),
                key: 'HEALTHSTATUS',
                enumMap: enumGet('HEALTHSTATUS'),
                templateName: 'FlagText',
                templateParams: {
                    colorMap: enumGet('HEALTHSTATUS_COLOR'),
                },
            },
            {
                title: I18N('common.runningStatus_column'),
                key: 'RUNNINGSTATUS',
                enumMap: enumGet('RUNNINGSTATUS'),
                templateName: 'FlagText',
                templateParams: {
                    colorMap: enumGet('RUNNINGSTATUS_COLOR'),
                },
            },
            {
                title: I18N('storage.lun_view_summary_localWWN_label'),
                key: 'WWN',
            },
            // 微存储屏蔽写策略
            ...(FeatureConfig.IsHideLunTableBusinessColumnDef ? [] : [
                {
                    title: I18N('storage.lun_view_summary_cacheWritetrategy_label'),
                    key: 'WRITEPOLICY',
                    enumMap: enumGet('WRITEPOLICY'),
                },
            ]),
            {
                title: I18N('system.ownStoragePool_label'),
                key: 'PARENTNAME',
            },
        ];
    }

    requestInfo(): Observable<HttpResponse> {
        return this.infigoService.getRecycleLunDetail(this.item.actionParams);
    }

    handleRequest(value): void {
        value.data = value.data[0];
        this.detail = value.data;
        this.detail.HASRSSOBJECT = pick(value.data.HASRSSOBJECT && JSON.parse(value.data.HASRSSOBJECT) || {}, HASRSSOBJECT);
        this.capacityPercentData = this.lunService.usageValue(value.data);
        this.updateThreShold(this.detail);
        this.loading = false;
        this.clearTimer();
        this.updateLoading = false;
        this.changeDetectorRef.detectChanges();
    }


    updateThreShold(data: { ENABLEISCSITHINLUNTHRESHOLD: string; ISCSITHINLUNTHRESHOLD: any }): void {
        this.threSholdList = data.ENABLEISCSITHINLUNTHRESHOLD === 'true' ?
            [{ value: Number(data.ISCSITHINLUNTHRESHOLD), color: '#f83' }] : [];
    }
}
